import { initEnvironment } from '@/lib/environment'

// Separate entry point to set environment variables
// before the rest of the app
initEnvironment()
